import { useEffect } from 'react';

const useHelmet = ({ canonicalLink, metaDescription, noIndex, title } = {}) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  // set the meta description tag
  useEffect(() => {
    if (metaDescription) {
      const element = document.createElement('meta');
      element.name = 'description';
      element.content = metaDescription;

      // attach all element to the DOM
      document.head.appendChild(element);

      // cleanup for the next route
      return () => document.head.removeChild(element);
    }
  }, [metaDescription]);

  useEffect(() => {
    if (canonicalLink) {
      const element = document.createElement('link');
      element.href = canonicalLink;
      element.rel = 'canonical';

      // attach all element to the DOM
      document.head.appendChild(element);

      return () => document.head.removeChild(element);
    }
  }, [canonicalLink]);

  useEffect(() => {
    if (noIndex) {
      const element = document.createElement('meta');
      element.name = 'robots';
      element.content = 'noindex';

      // attach all element to the DOM
      document.head.appendChild(element);

      return () => document.head.removeChild(element);
    }
  }, [noIndex]);
};

export default useHelmet;
